import styled from 'styled-components';
import { CheckCircleFilled } from '@ant-design/icons';
import { Space } from 'antd';
import { Button, Typography } from '@design-system/components';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { StyledModal } from './NotifyMeModal';

const StyledBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media screen and (min-width: 768px) {
    gap: 32px;
  }
`;

const StyledPassIcon = styled(CheckCircleFilled)`
  font-size: 78px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.color.background};
  color: ${(props) => props.theme.color.successHighEmphasis};
`;

const StyledContent = styled.div<{ isSoldStatus?: boolean; isMobile?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  .notify-me-content-desc {
    text-align: center;
  }
`;

const NotifyMeSuccessModal: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <StyledModal open>
      <StyledBody>
        <StyledPassIcon />
        <StyledContent>
          <Typography variant="header" className="notify-me-content-title">
            {t('shared.notifyMe.successModal.title')}
          </Typography>
          <Typography variant="body" className="notify-me-content-desc">
            {t('shared.notifyMe.successModal.desc')}
          </Typography>
        </StyledContent>
        <Button onClick={onClose}>{t('shared.notifyMe.modal.backToListing')}</Button>
      </StyledBody>
    </StyledModal>
  );
};

export default NotifyMeSuccessModal;
